import { httpClient } from '../../http-client';
import type { AppMarketRpcClient } from '../../types/app-market-rpc-client';

export const fetchDeveloperPageData =
  (
    companySlug: string,
    locale: string = 'en',
    rpcClient?: AppMarketRpcClient,
  ) =>
  () => {
    const isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
      return rpcClient
        .getCompanies({ idsOrSlugs: companySlug, lang: locale })
        .then((companiesResponse) => {
          return {
            company: companiesResponse.companies[0],
          };
        });
    }

    return httpClient
      .get(`/_api/marketplace-api/v1/company/${companySlug}?lang=${locale}`)
      .then((companiesResponse) => {
        return {
          company: companiesResponse?.data?.companies?.[0],
        };
      });
  };
